import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row w-full justify-content-center" }
const _hoisted_2 = { class: "border-0 rounded-0 bg-white" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_ctx.enabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["m-0 p-0 w-full", _ctx.isUserDataAvailable ? 'mb-25' : ''])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["col", _ctx.isUserDataAvailable ? 'col' : 'col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.loading === true)
                  ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                      key: 0,
                      class: "h-auto",
                      small: true
                    }))
                  : (_ctx.adverseEventConfig && _ctx.adverseEventConfig.enabled)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.descriptionParts.before), 1 /* TEXT */),
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.adverseEventConfig.email
                        }, _toDisplayString(_ctx.adverseEventConfig.email), 9 /* TEXT, PROPS */, _hoisted_5),
                        _createTextVNode(_toDisplayString(_ctx.descriptionParts.after), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
              ])
            ])
          ], 2 /* CLASS */)
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}